/* ===== Narra capture endpoint (Apps Script web app, anonymous POST) =====
   Appends to Sheet "Narra Receipt Entries" + saves photos to Drive "Narra Receipts". */
var CAPTURE_URL = 'https://script.google.com/macros/s/AKfycbyxHUnsmpq32bKDL3DHvV49a6Yz93Q1h619KIQ0yqZjNv10PXmyMAGft5vN6SbBLxmRmA/exec';
function submitEntry(form, data){
  var body = { form: form };
  for (var k in data){ if (data.hasOwnProperty(k)) body[k] = data[k]; }
  try {
    return fetch(CAPTURE_URL, { method:'POST', mode:'no-cors', body: JSON.stringify(body) });
  } catch(e){ return Promise.resolve(); }
}

(function(){
  var drop=document.getElementById('drop'), file=document.getElementById('file');
  var preview=document.getElementById('preview'), pimg=document.getElementById('pimg');
  var spin=document.getElementById('spin'), ocrline=document.getElementById('ocrline');
  var fields=document.getElementById('fields'), err=document.getElementById('err');
  var imageB64=null, ocrTotal=null, ocrText='';

  drop.addEventListener('click', function(){ file.click(); });
  drop.addEventListener('dragover', function(e){ e.preventDefault(); drop.classList.add('over'); });
  drop.addEventListener('dragleave', function(){ drop.classList.remove('over'); });
  drop.addEventListener('drop', function(e){ e.preventDefault(); drop.classList.remove('over'); if(e.dataTransfer.files[0]) handle(e.dataTransfer.files[0]); });
  file.addEventListener('change', function(){ if(file.files[0]) handle(file.files[0]); });

  function fail(msg){ err.style.display='block'; err.textContent=msg; spin.style.display='none'; }

  function handle(f){
    err.style.display='none';
    var img=new Image();
    img.onload=function(){
      var s1=Math.min(1,1600/Math.max(img.width,img.height));
      var big=document.createElement('canvas'); big.width=Math.round(img.width*s1); big.height=Math.round(img.height*s1);
      big.getContext('2d').drawImage(img,0,0,big.width,big.height);
      var s2=Math.min(1,900/Math.max(img.width,img.height));
      var small=document.createElement('canvas'); small.width=Math.round(img.width*s2); small.height=Math.round(img.height*s2);
      small.getContext('2d').drawImage(img,0,0,small.width,small.height);
      imageB64=small.toDataURL('image/jpeg',0.6);
      pimg.src=imageB64; preview.style.display='block'; fields.style.display='block';
      runOcr(big);
    };
    img.onerror=function(){ fail("We could not read that file. Try a JPG or PNG photo of the receipt."); };
    img.src=URL.createObjectURL(f);
  }

  function runOcr(canvas){
    spin.style.display='block'; ocrline.style.display='none';
    if(typeof Tesseract==='undefined'){ spin.style.display='none'; ocrline.style.display='block'; ocrline.innerHTML="Type your receipt total below and you are set."; return; }
    Tesseract.recognize(canvas,'eng').then(function(res){
      spin.style.display='none';
      ocrText=(res.data&&res.data.text)||'';
      var totals=[];
      ocrText.split('\n').forEach(function(line){
        var mm=line.match(/(\d{1,4}\.\d{2})/g); if(!mm) return;
        var v=parseFloat(mm[mm.length-1]);
        if(/total|amount|balance|due/i.test(line)) totals.push({v:v,w:2}); else totals.push({v:v,w:1});
      });
      var best=null; totals.forEach(function(t){ if(!best||t.w>best.w||(t.w===best.w&&t.v>best.v)) best=t; });
      if(best&&best.v>0){ ocrTotal=best.v.toFixed(2); document.getElementById('total').value=ocrTotal;
        ocrline.style.display='block'; ocrline.innerHTML='We read a total of <b>$'+ocrTotal+'</b>. Double check it below and correct it if we misread.';
      } else { ocrline.style.display='block'; ocrline.innerHTML="We could not read the total off the photo. Type it in below and you are set."; }
    }).catch(function(){ spin.style.display='none'; ocrline.style.display='block'; ocrline.innerHTML="We could not read the total off the photo. Type it in below and you are set."; });
  }

  document.getElementById('submit').addEventListener('click', function(){
    err.style.display='none';
    var total=document.getElementById('total').value.trim().replace(/[^0-9.]/g,'');
    var name=document.getElementById('name').value.trim();
    var email=document.getElementById('email').value.trim();
    var ordernum=document.getElementById('ordernum').value.trim();
    if(!imageB64) return fail('Add a photo of your Amazon receipt first.');
    if(!total||isNaN(parseFloat(total))||parseFloat(total)<=0) return fail('Confirm your receipt total.');
    if(!name) return fail('Add your name.');
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Add a valid email so we can send your cashback.');
    if(!ordernum) return fail('Add your Amazon order number.');
    submitEntry('receipts', { name:name, email:email, orderNumber:ordernum, total:total, ocrTotal:ocrTotal, photo:imageB64, ua:navigator.userAgent });
    document.getElementById('scanmain').style.display='none';
    document.getElementById('done').style.display='block';
    document.getElementById('scan').scrollIntoView({behavior:'smooth',block:'start'});
  });
})();
